import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import FormInput from "@casino/legacyUi/form/FormInput";
import FormSelect from "@casino/legacyUi/form/FormSelect";
import { cn } from "@workspace/frontend-ui";
import type { RegisterOptions } from "react-hook-form";
import usePhoneFields from "./hooks/usePhoneFields";

type Props = {
  value: string;
  onChange: (phoneString: string) => void;
  error?: string;
  rules?: RegisterOptions;
  label?: string;
  excludedCountries?: string[];
};

const PhoneFields = ({
  onChange,
  value,
  label,
  error,
  excludedCountries,
}: Props) => {
  const { isMobile } = useAgentData();

  const {
    countryCode,
    phoneNumber,
    primaryOptions,
    secondaryOptions,
    handleCodeChange,
    handleNumberChange,
  } = usePhoneFields({ value, onChange, excludedCountries });

  return (
    <div
      className={cn(
        "grid grid-flow-col grid-cols-[max-content_1fr] items-end gap-4",
        isMobile && "grid-cols-2",
      )}
    >
      <FormSelect
        label="profile.country_code"
        options={[...primaryOptions, ...secondaryOptions]}
        onChange={handleCodeChange}
        data-testid="countryCode"
        value={countryCode}
        enableEmptyValue
        error={error}
        skipErrorMessage
      />
      <FormInput
        type="tel"
        label={label || "profile.phone"}
        data-testid="phone"
        value={phoneNumber}
        onChange={handleNumberChange}
        error={error}
        skipErrorMessage
        className="fs-mask"
      />
    </div>
  );
};

export default PhoneFields;
